module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"and":"and"},"de":{"and":"und"},"fr":{"and":"et"},"it":{"and":"e"}}')
  delete Component.options._Ctor
}
